
import { defineComponent, ref } from 'vue';
import Heading from '@/components/atoms/Heading.vue';
import DialogBox from '@/components/molecules/DialogBox.vue';
import ProgramCard from '@/components/organisms/program/ProgramCard.vue';
import { useI18n } from '@/plugins/i18n';

export default defineComponent({
  name: 'ProgramBody',
  components: {
    Heading,
    DialogBox,
    ProgramCard,
  },
  props: {
    i18n: {
      type: Object,
    },
  },
  data() {
    return {
      dialogTimetable: false,
      dialogMap: false,
      eventData: [
        {
          id: 'avatar_dressing_room',
          image: ref().value = require('@/assets/images/program/program-avatar.jpg'),
          platform: ['VRChat', 'NeosVR'],
          date: '常設企画',
          date_en: 'Permanent Program',
          title: 'アバター試着室',
          title_en: 'Avatar Changing Room',
          place: 'アバター試着室',
          place_en: 'Avatar Changing Room',
          description:
            'アバター試着室では、皆さんから事前に募集したいろいろな種族のケモノアバターを体験することができます。きっとあなたのお気に入りのアバターも見つかるはず！ ぜひ体験しに来てくださいね♪',
          description_en:
            "At the Avatar Changing Room, you can try out various furry avatars submitted by everyone before the event. We're sure you'll find an avatar that suits you best! Please come and try them on♪",
          access:
            'VR JMoFワールドの「アバター試着室」で各種アバターを体験できます。',
          access_en:
            'You can try out various avatars in the “Avatar Changing Room” in the VR JMoF world.',
        },
        {
          id: 'poster_exhibition',
          image: ref().value = require('@/assets/images/program/program-poster.jpg'),
          platform: ['VRChat', 'NeosVR'],
          date: '常設企画',
          date_en: 'Permanent Program',
          title: 'ポスター展示',
          title_en: 'Poster Exhibition',
          place: 'ホワイエ',
          place_en: 'Foyer',
          description:
            'ケモノやVRに関するポスターを、VR JMoFワールドに一挙展示します！ いろいろなイベントやケモノサークルを知ることができるかも……！？ 新しいジャンル・情報を知りたい方は要チェック！',
          description_en:
            "We'll be exhibiting posters related to “VR” and “Furries” in the VR JMoF world! You may be able to learn about various events or furry clubs...!? Check them out if you want to know about new genre and information!",
          access: 'VR JMoFワールドの「ホワイエ」で展示をご覧になれます。',
          access_en:
            'You can see the exhibit at the “Foyer” in the VR JMoF world.',
        },
        {
          id: 'lounge',
          image: ref().value = require('@/assets/images/program/program-lounge.jpg'),
          platform: ['Streaming'],
          title: '【JMoFコラボ】VRラウンジ',
          title_en: '[JMoF Collab] VR Lounge',
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            'JMoF 2023ではVRラウンジが復活！VRラウンジの開催時間中は、現地会場とVR JMoF会場とを繋いだ相互配信を実施します。<br />リアルもふもふたちにバーチャルもふもふを見せつけよう！',
          description_en:
            'VR Lounge is back at JMoF 2023! During the hours of VR Lounge, our official video streaming will connect the real JMoF venue with VR JMoF worlds.',
          access:
            'VR JMoFワールド内の配信画面、および公式動画配信に、両会場内の様子が配信されます。',
          access_en:
            'You can watch the mutual distribution on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: [
            '※1月5日（木）のVRラウンジは、ウェルカムラウンジ内で開催されます。',
            '※企画の実施中や配信中は、相互配信が中断されることがあります。',
            '※VRラウンジの詳細は<a href="https://www.jmof.jp/lounge/vr">JMoF公式ウェブサイト</a>をご覧ください。',
          ],
          attention_en: [
            'Note: The VR Lounge on January 5th (Thu.) will be held in the Welcome Lounge.',
            'Note: Mutual distribution may be interrupted while we are running and/or streaming other programs.',
            'Note: Please visit the <a href="https://www.jmof.jp/en/lounge/vr">official JMoF website</a> for more information about VR Lounge.',
          ],
        },

        {
          id: 'experience',
          image: ref().value = require('@/assets/images/program/program-experience.jpg'),
          platform: ['VRChat'],
          title: '【JMoFコラボ】VR体験会',
          title_en: '[JMoF Collab] VR Experience',
          place: 'VR JMoF公式インスタンス（VRChat）',
          place_en: 'VR JMoF Official Instances (VRChat)',
          description:
            'どこかのインスタンスで、JMoF 2023で行われるVR体験会の参加者に出会うことができるかも……！？　VRに興味を持ってくれた初心者に魅力を伝えるチャンス！　VR体験中の参加者を見かけたらぜひ優しく話しかけてあげてくださいね。',
          description_en:
            "In some instances, you may meet a participant of the VR experience session at JMoF 2023...!? It's your chance to show the charms of VR to these interested newbies! If you see a participant experiencing VR, please be sure to talk to them kindly.",
          attention: [
            '※VR体験会の参加者は、“JMoF_VR_xx”というスクリーンネームになっています。末尾のxxには01～05の数字が入ります。',
          ],
          attention_en: [
            'Note: The participants of the VR Experience have the screen name “JMoF_VR_xx”, where the xx at the end is a number between 01 and 05.',
          ],
        },

        {
          id: 'whiteboard1',
          title: '【JMoFコラボ】リアルVRホワイトボード①',
          title_en: '[JMoF Collab] Real VR Whiteboard #1',
          date: '1月6日（金） 12:00〜13:00',
          date_en: 'January 6th (Fri.) 12:00 - 13:00 JST',
          datelabel: 'day_2',
          image: ref().value = require('@/assets/images/program/program-whiteboard.jpg'),
          platform: ['VRChat'],
          place: '桃の間',
          place_en: 'Room “Momo”',
          description:
            'JMoFでもVR JMoFでもおなじみのホワイトボード、今回もリアル／バーチャルどちらの会場からも書き込める「リアルVRホワイトボード」を時間限定で設置します！　イラストを通じてJMoF参加者と楽しく交流してみませんか？　VR JMoF期間中に全4回の開催を予定しています。',
          description_en:
            "While a whiteboard has been a familiar feature at both JMoF and VR JMoF, this time we'll set up a “Real VR Whiteboard”, where you can write from both the real and the virtual venue again! Why don't you have fun interacting with JMoF attendees through illustrations? We're going to hold a total of four sessions during the VR JMoF.",
          access:
            '企画開始時刻までに、公式動画配信にて、開催されるインスタンスの告知を行います。参加を希望される方は、「会場一覧」ページから告知されたインスタンスにJoinして、「桃の間」までお越しください。',
          access_en:
            'We will announce the venue instance on the official video streaming by the starting time. If you want to participate, please join the announced instance from the “World List” page and come to the Room “Momo”.',
        },
        {
          id: 'whiteboard2',
          title: '【JMoFコラボ】リアルVRホワイトボード②',
          title_en: '[JMoF Collab] Real VR Whiteboard #2',
          date: '1月6日（金） 15:00〜16:00',
          date_en: 'January 6th (Fri.) 15:00 - 16:00 JST',
          datelabel: 'day_2',
          image: ref().value = require('@/assets/images/program/program-whiteboard.jpg'),
          platform: ['VRChat'],
          place: '桃の間',
          place_en: 'Room “Momo”',
          description:
            'JMoFでもVR JMoFでもおなじみのホワイトボード、今回もリアル／バーチャルどちらの会場からも書き込める「リアルVRホワイトボード」を時間限定で設置します！　イラストを通じてJMoF参加者と楽しく交流してみませんか？　VR JMoF期間中に全4回の開催を予定しています。',
          description_en:
            "While a whiteboard has been a familiar feature at both JMoF and VR JMoF, this time we'll set up a “Real VR Whiteboard”, where you can write from both the real and the virtual venue again! Why don't you have fun interacting with JMoF attendees through illustrations? We're going to hold a total of four sessions during the VR JMoF.",
          access:
            '企画開始時刻までに、公式動画配信にて、開催されるインスタンスの告知を行います。参加を希望される方は、「会場一覧」ページから告知されたインスタンスにJoinして、「桃の間」までお越しください。',
          access_en:
            'We will announce the venue instance on the official video streaming by the starting time. If you want to participate, please join the announced instance from the “World List” page and come to the Room “Momo”.',
        },

        {
          id: 'opening',
          title: '開会式',
          title_en: 'Opening Ceremony',
          date: '1月6日（金） 18:00〜18:30',
          date_en: 'January 6th (Fri.) 18:00 - 18:30 JST',
          datelabel: 'day_2',
          image: ref().value = require('@/assets/images/program/program-opening.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            'VR JMoF始まるよ！！！　実施概要、参加にあたっての注意事項、企画の内容などを説明します！　ここから参加してお祭り気分になっちゃいましょう！！',
          description_en:
            "The VR JMoF BEGINS!!! We'll explain the schedule outline, precautions for participation, event contents and so on! From here on out, let's join in and get into a festive mood!!",
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: ['※この企画は日本語のみで進行します。'],
          attention_en: [
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'tfportal1',
          title: '【JMoFコラボ】TFPortal ①',
          title_en: '[JMoF Collab] TFPortal #1',
          date: '1月6日（金） 19:00〜21:00',
          date_en: 'January 6th (Fri.) 19:00 - 21:00 JST',
          datelabel: 'day_2',
          image: ref().value = require('@/assets/images/program/program-tfportal.jpg'),
          platform: ['NeosVR'],
          place: 'VR JMoF公式セッション（NeosVR）',
          place_en: 'VR JMoF Official Sessions (NeosVR)',
          description:
            'なんと今回はJMoF現地会場でNeosVR企画を開催！VRからは企画に直接参加することはできませんが、Neos会場では現地参加者との交流や記念撮影ができるかも…？！　VR JMoF期間中に全3回の開催を予定しています。<br />「獣化の鏡でTF(TransFur)体験！現実とメタバースの融合であなたもケモノになれちゃう！？　鏡の世界で獣化して他のケモノと交流したり、好きなポーズで記念撮影！撮った写真を共有して友達をびっくりさせちゃおう！」',
          access:
            '企画開催時間中、NeosVRのVR JMoF公式セッション内から、TFPortalの会場セッションに移動することができます。参加を希望される方は、「会場一覧」ページからいずれかの公式セッションにJoinしてください。',
          attention: [
            '※JMoF現地会場から企画に参加したいJMoF 2023参加者の方は、企画開催時間中に「ホール・ロビー」のTFPortal開催場所にお越しください。',
          ],
        },
        {
          id: 'mahjong',
          title: 'NEO麻雀リーグエキシビション',
          title_en: 'NEOMahjong Exhibition Match',
          date: '1月6日（金） 20:00〜21:00',
          date_en: 'January 6th (Fri.) 20:00 - 21:00 JST',
          datelabel: 'day_2',
          image: ref().value = require('@/assets/images/program/program-mahjong.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            '役満だらけの次世代麻雀「NEO麻雀」！カオスな麻雀対決を見逃すな！<br />対局参加者：Aetoriz，AoiOrca，ismi，YAKORUSU（敬称略）',
          description_en:
            "“NEOMahjong” is the Next-Generation-Mahjong that full of exciting monents! Don't miss this chaotic mahjong showdown!<br />Players: Aetoriz, AoiOrca, ismi, YAKORUSU",
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: ['※この企画は日本語のみで進行します。'],
          attention_en: [
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'radio1',
          title: '【JMoFコラボ】ラジオ体操①',
          title_en: '[JMoF Collab] Morning Radio Exercises #1',
          date: '1月7日（土） 7:30',
          date_en: 'January 7th (Sat.) 7:30 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-radio.jpg'),
          platform: ['VRChat'],
          place: 'ホール・ロビー／公式動画配信',
          place_en: 'Hall Lobby / Official Video Streaming',
          description:
            'わずかなコンベンション期間に寝過ごしちゃうなんてもったいない！　今日も元気にラジオ体操でVR JMoF 3日目をスタートだ！　今回もJMoF 2023とコラボレーションし、ロワジールホテル豊橋でのラジオ体操の様子を生配信！　着ぐるみさんたちと一緒に元気に一日を始めちゃおう！',
          description_en:
            "What a waste of time to oversleep during this short convention period! Let's kick off the third day of VR JMoF with a vigorous radio exercise! This time, in collaboration with JMoF 2023, we'll be broadcasting live the radio exercises at the Loisir Hotel Toyohashi! Let's get the day started off with furry friends together!",
          access:
            '企画開始時刻までに、いずれかの公式インスタンスにJoinして、「ホール・ロビー」の配信画面前に集合してください。<br />なお、JMoF現地会場の様子は、VR JMoFの公式動画配信からもご覧いただけます。',
          access_en:
            'Please join either of the official instances and gather in front of the streaming screen located in the “Hall Lobby”.<br />The scene in the real JMoF venue can also be viewed from the official VR JMoF video streaming.',
        },
        {
          id: 'jfcc',
          title: '【JMoF配信】着ぐるみクリエイターコンテスト2023',
          title_en: "[JMoF Streaming] Japan Fursuit Creators' Competition 2023",
          date: '1月7日（土） 10:30〜12:30',
          date_en: 'January 7th (Sat.) 10:30 - 12:30 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-jfcc.png'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            '毎年素晴らしい着ぐるみクリエイターたちが集う着ぐるみクリエイターコンテストの様子を、VR JMoFにもお届けします！',
          description_en:
            "Japan Fursuit Creators' Competition, where amazing creators gather every year, will be brought to you in VR JMoF!",
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: [
            '※着ぐるみクリエイターコンテスト2023の詳細は<a href="https://www.jmof.jp/event/fursuit_creators_competition">JMoF公式ウェブサイト</a>をご覧ください。',
            '※この企画は日本語のみで進行します。',
          ],
          attention_en: [
            'Note: Please visit the <a href="https://www.jmof.jp/en/event/fursuit_creators_competition">official JMoF website</a> for more information about Japan Fursuit Creators\' Competition 2023.',
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'manekabe',
          title: 'マネ壁',
          title_en: 'mimic the wall',
          date: '1月7日（土） 13:00〜14:30',
          date_en: 'January 7th (Sat.) 13:00 - 14:30 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-manekabe.jpg'),
          platform: ['NeosVR'],
          place: 'VR JMoF公式セッション（NeosVR）',
          place_en: 'VR JMoF Official Sessions (NeosVR)',
          description:
            '迫り来る壁を個性的なポーズでくぐり抜け、スコアランキング1位を目指せ！<br />フルトラでも楽しめる上に、3点トラッキングでもバッチリできちゃいます。さらにはペアでの挑戦も可能！あなたは迫り来る壁を見事くぐり抜けることができるかな？',
          access:
            '参加を希望される方は、「会場一覧」ページからいずれかの公式セッションにJoinしてください。',
        },
        {
          id: 'tfportal2',
          title: '【JMoFコラボ】TFPortal ②',
          title_en: '[JMoF Collab] TFPortal #2',
          date: '1月7日（土） 13:00〜15:00',
          date_en: 'January 7th (Sat.) 13:00 - 15:00 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-tfportal.jpg'),
          platform: ['NeosVR'],
          place: 'VR JMoF公式セッション（NeosVR）',
          place_en: 'VR JMoF Official Sessions (NeosVR)',
          description:
            'なんと今回はJMoF現地会場でNeosVR企画を開催！VRからは企画に直接参加することはできませんが、Neos会場では現地参加者との交流や記念撮影ができるかも…？！　VR JMoF期間中に全3回の開催を予定しています。<br />「獣化の鏡でTF(TransFur)体験！現実とメタバースの融合であなたもケモノになれちゃう！？　鏡の世界で獣化して他のケモノと交流したり、好きなポーズで記念撮影！撮った写真を共有して友達をびっくりさせちゃおう！」',
          access:
            '企画開催時間中、NeosVRのVR JMoF公式セッション内から、TFPortalの会場セッションに移動することができます。参加を希望される方は、「会場一覧」ページからいずれかの公式セッションにJoinしてください。',
          attention: [
            '※JMoF現地会場から企画に参加したいJMoF 2023参加者の方は、企画開催時間中に「ホール・ロビー」のTFPortal開催場所にお越しください。',
          ],
        },
        {
          id: 'rock_festival',
          title: '【JMoF配信】JMoF Rock Festival 2023',
          title_en: '[JMoF Streaming] JMoF Rock Festival 2023',
          date: '1月7日（土） 16:00〜19:30',
          date_en: 'January 7th (Sat.) 16:00 - 19:30 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-rock.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            '毎年Furryミュージシャンたちによる素晴らしいライブ演奏が繰り広げられるJMoF Rock Festival、今回もVR JMoFワールドへもリアルタイムでお届けします！',
          description_en:
            'The JMoF Rock Festival, which brings you amazing live performances by furry musicians every year, will now be brought live to the VR JMoF world!',
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: [
            '※JMoF Rock Festival 2023の詳細は<a href="https://www.jmof.jp/event/rock_festival">JMoF公式ウェブサイト</a>をご覧ください。',
          ],
          attention_en: [
            'Note: Please visit the <a href="https://www.jmof.jp/en/event/rock_festival">official JMoF website</a> for more information about JMoF Rock Festival 2023.',
          ],
        },
        {
          id: 'whiteboard3',
          title: '【JMoFコラボ】リアルVRホワイトボード③',
          title_en: '[JMoF Collab] Real VR Whiteboard #3',
          date: '1月7日（土） 17:00〜18:00',
          date_en: 'January 7th (Sat.) 17:00 - 18:00 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-whiteboard.jpg'),
          platform: ['VRChat'],
          place: '桃の間',
          place_en: 'Room “Momo”',
          description:
            'JMoFでもVR JMoFでもおなじみのホワイトボード、今回もリアル／バーチャルどちらの会場からも書き込める「リアルVRホワイトボード」を時間限定で設置します！　イラストを通じてJMoF参加者と楽しく交流してみませんか？　VR JMoF期間中に全4回の開催を予定しています。',
          description_en:
            "While a whiteboard has been a familiar feature at both JMoF and VR JMoF, this time we'll set up a “Real VR Whiteboard”, where you can write from both the real and the virtual venue again! Why don't you have fun interacting with JMoF attendees through illustrations? We're going to hold a total of four sessions during the VR JMoF.",
          access:
            '企画開始時刻までに、公式動画配信にて、開催されるインスタンスの告知を行います。参加を希望される方は、「会場一覧」ページから告知されたインスタンスにJoinして、「桃の間」までお越しください。',
          access_en:
            'We will announce the venue instance on the official video streaming by the starting time. If you want to participate, please join the announced instance from the “World List” page and come to the Room “Momo”.',
        },
        {
          id: 'fetish_talk',
          title: '【JMoF配信】フェチトーーク！！',
          title_en: '[JMoF Streaming] Fetish Taalk!!',
          date: '1月7日（土） 19:30〜20:30',
          date_en: 'January 7th (Sat.) 19:30 - 20:30 JST',
          datelabel: 'day_3',
          image: ref().value = require('@/assets/images/program/program-fetish_talk.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            '性癖・フェチについて語らう会をJMoF 2023で開催します。初回のテーマは「ポケモンになりた～～い！」！　ディープなトークがあなたを待っている！！',
          description_en:
            'A meeting to talk about fetishes will be held at JMoF 2023. The theme of the first meeting is “I want to be a Pokemon!!”. Deep talks are waiting for you!',
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: ['※この企画は日本語のみで進行します。'],
          attention_en: [
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'radio2',
          title: '【JMoFコラボ】ラジオ体操②',
          title_en: '[JMoF Collab] Morning Radio Exercises #2',
          date: '1月8日（日） 7:30',
          date_en: 'January 8th (Sun.) 7:30 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-radio.jpg'),
          platform: ['VRChat'],
          place: 'ホール・ロビー／公式動画配信',
          place_en: 'Hall Lobby / Official Video Streaming',
          description:
            'わずかなコンベンション期間に寝過ごしちゃうなんてもったいない！　今日も元気にラジオ体操でVR JMoF 最終日をスタートだ！　今回もJMoF 2023とコラボレーションし、ロワジールホテル豊橋でのラジオ体操の様子を生配信！　着ぐるみさんたちと一緒に元気に一日を始めちゃおう！',
          description_en:
            "What a waste of time to oversleep during this short convention period! Let's kick off the final day of VR JMoF with a vigorous radio exercise! This time, in collaboration with JMoF 2023, we'll be broadcasting live the radio exercises at the Loisir Hotel Toyohashi! Let's get the day started off with furry friends together!",
          access:
            '企画開始時刻までに、いずれかの公式インスタンスにJoinして、「ホール・ロビー」の配信画面前に集合してください。<br />なお、JMoF現地会場の様子は、VR JMoFの公式動画配信からもご覧いただけます。',
          access_en:
            'Please join either of the official instances and gather in front of the streaming screen located in the “Hall Lobby”.<br />The scene in the real JMoF venue can also be viewed from the official VR JMoF video streaming.',
        },
        {
          id: 'whiteboard4',
          title: '【JMoFコラボ】リアルVRホワイトボード④',
          title_en: '[JMoF Collab] Real VR Whiteboard #4',
          date: '1月8日（日） 11:00〜12:00',
          date_en: 'January 8th (Sun.) 11:00 - 12:00 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-whiteboard.jpg'),
          platform: ['VRChat'],
          place: '桃の間',
          place_en: 'Room “Momo”',
          description:
            'JMoFでもVR JMoFでもおなじみのホワイトボード、今回もリアル／バーチャルどちらの会場からも書き込める「リアルVRホワイトボード」を時間限定で設置します！　イラストを通じてJMoF参加者と楽しく交流してみませんか？　VR JMoF期間中に全4回の開催を予定しています。',
          description_en:
            "While a whiteboard has been a familiar feature at both JMoF and VR JMoF, this time we'll set up a “Real VR Whiteboard”, where you can write from both the real and the virtual venue again! Why don't you have fun interacting with JMoF attendees through illustrations? We're going to hold a total of four sessions during the VR JMoF.",
          access:
            '企画開始時刻までに、公式動画配信にて、開催されるインスタンスの告知を行います。参加を希望される方は、「会場一覧」ページから告知されたインスタンスにJoinして、「桃の間」までお越しください。',
          access_en:
            'We will announce the venue instance on the official video streaming by the starting time. If you want to participate, please join the announced instance from the “World List” page and come to the Room “Momo”.',
        },
        {
          id: 'tfportal3',
          title: '【JMoFコラボ】TFPortal ③',
          title_en: '[JMoF Collab] TFPortal #3',
          date: '1月8日（日） 13:00〜15:00',
          date_en: 'January 8th (Sun.) 13:00 - 15:00 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-tfportal.jpg'),
          platform: ['NeosVR'],
          place: 'VR JMoF公式セッション（NeosVR）',
          place_en: 'VR JMoF Official Sessions (NeosVR)',
          description:
            'なんと今回はJMoF現地会場でNeosVR企画を開催！VRからは企画に直接参加することはできませんが、Neos会場では現地参加者との交流や記念撮影ができるかも…？！　VR JMoF期間中に全3回の開催を予定しています。<br />「獣化の鏡でTF(TransFur)体験！現実とメタバースの融合であなたもケモノになれちゃう！？　鏡の世界で獣化して他のケモノと交流したり、好きなポーズで記念撮影！撮った写真を共有して友達をびっくりさせちゃおう！」',
          access:
            '企画開催時間中、NeosVRのVR JMoF公式セッション内から、TFPortalの会場セッションに移動することができます。参加を希望される方は、「会場一覧」ページからいずれかの公式セッションにJoinしてください。',
          attention: [
            '※JMoF現地会場から企画に参加したいJMoF 2023参加者の方は、企画開催時間中に「ホール・ロビー」のTFPortal開催場所にお越しください。',
          ],
        },
        {
          id: 'furresearch',
          title: '【JMoF配信】けもなーじゆうけんきゅう',
          title_en: "[JMoF Streaming] Furries' Everything Is Research",
          date: '1月8日（日） 13:00〜14:30',
          date_en: 'January 8th (Sun.) 13:00 - 14:30 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-research.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            'JMoF 2023内で開催される、ケモノに関係する内容ならなんでもOKのプレゼン会「けもなーじゆうけんきゅう」を、VR JMoF内で配信します。気軽にJoinして、いろいろな「じゆうけんきゅう」を聞いてみませんか？',
          description_en:
            "The “Furries' Everything Is Research”, a presentation session about anything related to Kemono at JMoF 2023, will be broadcasted in VR JMoF. Feel free to join us and listen to a variety of their 'research'!",
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: [
            '※けもなーじゆうけんきゅうの詳細は<a href="https://www.jmof.jp/event/presentation_session">JMoF公式ウェブサイト</a>をご覧ください。',
            '※この企画は日本語のみで進行します。',
          ],
          attention_en: [
            'Note: Please visit the <a href="https://www.jmof.jp/en/event/presentation_session">official JMoF website</a> for more information about Furries\' Everything Is Research.',
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'stage',
          title: '【JMoF配信】パフォーマンスステージ「Back to the 90’s」',
          title_en: '[JMoF Streaming] Performance Stage “Back to the 90’s”',
          date: '1月8日（日） 15:00〜17:00',
          date_en: 'January 8th (Sun.) 15:00 - 17:00 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-stage.png'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            '毎年大人気のJMoFパフォーマンスステージをVRにも同時配信！　圧巻のステージをぜひお楽しみください！',
          description_en:
            'JMoF Performance Stage is now available in VR JMoF at the same time! Enjoy the stunning stage performance!',
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: [
            '※パフォーマンスステージの詳細は<a href="https://www.jmof.jp/event/performance_stage">JMoF公式ウェブサイト</a>をご覧ください。',
            '※この企画は日本語のみで進行します。',
          ],
          attention_en: [
            'Note: Please visit the <a href="https://www.jmof.jp/en/event/performance_stage">official JMoF website</a> for more information about Performance Stage.',
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'jmof_closing',
          title: '【JMoF配信】表彰式＆閉会式',
          title_en: '[JMoF Streaming] Award Ceremonies and Closing Ceremony',
          date: '1月8日（日） 17:00〜18:30',
          date_en: 'January 8th (Sun.) 17:00 - 18:30 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-closing_jmof.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            'JMoF 2023で行われる「JMoFイラストコンテスト2023」「ケモノストーリーコンテスト2023」「Japan Furries Photo Competition 2023」の表彰式、そしてJMoF 2023の閉会式の様子をお届けします。',
          description_en:
            'Award Ceremonies for “JMoF Art Competition 2023”, “Kemono Story Contest 2023”, and “Japan Furries Photo Competition 2023”, as well as the closing ceremony of JMoF 2023, will be streamed.',
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: ['※この企画は日本語のみで進行します。'],
          attention_en: [
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'vr_closing',
          title: '閉会式',
          title_en: 'Closing Ceremony',
          date: '1月8日（日） 18:30〜18:45',
          date_en: 'January 8th (Sun.) 18:30 - 18:45 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-ending.jpg'),
          platform: ['Streaming'],
          place: '公式動画配信',
          place_en: 'Official Video Streaming',
          description:
            'VR JMoF 2023を締めくくるプログラムです。スタッフや協力してくださった方々の紹介、そして閉会宣言を行ないます。ぜひご参加ください。',
          description_en:
            'This is the program to complete the VR JMoF 2023. We will introduce the staff and contributors, and conclude the event. Please come and join us.',
          access:
            'VR JMoFワールド内の配信画面、または公式動画配信から、企画の様子を視聴できます。',
          access_en:
            'You can watch the program on streaming screens in the VR JMoF world, or on the official video streaming.',
          attention: ['※この企画は日本語のみで進行します。'],
          attention_en: [
            'Note: This event will be held in the Japanese language only.',
          ],
        },
        {
          id: 'vrchat_photo',
          title: 'VRChat集合写真',
          title_en: 'VRChat Group Photo',
          date: '1月8日（日） 18:45〜19:00',
          date_en: 'January 8th (Sun.) 18:45 - 19:00 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-photo.jpg'),
          platform: ['VRChat'],
          place: 'ホールD',
          place_en: 'Hall D',
          description:
            'ケモノイベントの目玉ともいえる集合写真、今回はホールDで撮影します。シャッター時刻に遅れないように集合だ！<br />（シャッター時刻 19:00）',
          description_en:
            "The group photo, the most important feature of the furry event, will be taken in the Hall D. Make sure you don't miss the shutter time!<br />(Picture taken at 19:00 JST)",
          access:
            'いずれかの公式セッションにJoinして「ホールD」に集合し、シャッター時刻までにカメラの設置および整列を完了させ、シャッター時刻になったら各自で撮影を行なってください。',
          access_en:
            'Please join either of the official sessions and gather at the “Hall D”, set up your camera and line up before the shutter time. Then take pictures by yourself when the shutter time comes.',
          attention: ['※スタッフによる公式撮影は行いません。'],
          attention_en: [
            'Note: There will be no official photo shooting by staff.',
          ],
        },
        {
          id: 'neos_photo',
          title: 'NeosVR集合写真',
          title_en: 'NeosVR Group Photo',
          date: '1月8日（日） 19:45〜20:00',
          date_en: 'January 8th (Sun.) 19:45 - 20:00 JST',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-photo_neos.jpg'),
          platform: ['NeosVR'],
          place: '中庭',
          place_en: 'Courtyard',
          description:
            'ケモノイベントの目玉ともいえる集合写真、もちろんNeosVRでも撮影します。シャッター時刻に遅れないように集合だ！<br />（シャッター時刻 20:00）',
          description_en:
            "The group photo, the most important feature of the furry event, will be also taken in the NeosVR. Make sure you don't miss the shutter time!<br />(Picture taken at 20:00 JST)",
          access:
            'いずれかの公式セッションにJoinして「中庭」に集合し、シャッター時刻までにカメラの設置および整列を完了させ、シャッター時刻になったら各自で撮影を行なってください。',
          access_en:
            'Please join either of the official sessions and gather at the “Courtyard”, set up your camera and line up before the shutter time. Then take pictures by yourself when the shutter time comes.',
          attention: ['※スタッフによる公式撮影は行いません。'],
          attention_en: [
            'Note: There will be no official photo shooting by staff.',
          ],
        },
        {
          id: 'dead_dog_party',
          title: 'デッドドッグパーティー',
          title_en: 'Dead Dog Party',
          date: '1月8日（日） 20:30～',
          date_en: 'January 8th (Sun.) 20:30 JST -',
          datelabel: 'day_4',
          image: ref().value = require('@/assets/images/program/program-ddp.jpg'),
          platform: ['VRChat', 'NeosVR'],
          description:
            'えっ！！！ VR JMoF終わってないじゃん！！？！？ そう、デッドドッグパーティーが残っている……。いうなれば公式2次会です。なんとVRならみんな安全にお酒が飲めるッ！！ 羽目を外しても自己責任！！ 末法の世の終わらない飲み会へようこそ！！！！！！',
          description_en:
            "Wait, what? VR JMoF hasn't finished yet!? That's right, we still have the Dead Dog Party left... It's so to speak the official after-party. What's more, everyone can drink safely in VR! You're on your own even if you cut loose! Welcome to the never-ending drinking party in this crazy world!!",
          access:
            '閉会式後に一度休憩して、オフロに入って、酒とツマミを用意して、その画像を「#VR_MELTDOWN」のハッシュタグをつけてTwitterにアップロードして、もう一度VR JMoFにJoinだ！！！',
          access_en:
            'After the Closing Ceremony, take a rest, take a bath, prepare some drinks and snacks, upload that image to Twitter with the hashtag #VR_MELTDOWN, and join VR JMoF once again!',
          attention: ['※閉会後のため、スタッフによる会場の管理は行いません。'],
          attention_en: [
            'Note: Instances/sessions will not be managed by staff as the event has closed.',
          ],
        },
      ],
    };
  },
  setup() {
    const i18n = useI18n();
    const locale = i18n.locale;
    return {
      locale,
    };
  },
});
